export default {
    inserted(el, binding) {
        let isComposing = false;
        const filterNumber = (value) => value.replace(/[^\d]/g, '');
        const handleInput = (e) => {
            if (isComposing) return;
            const newValue = filterNumber(e.target.value);
            if (e.target.value !== newValue) {
                const cursorPos = e.target.selectionStart - (e.target.value.length - newValue.length);
                e.target.value = newValue;
                e.target.setSelectionRange(cursorPos, cursorPos);
            }
        };
        el.addEventListener('compositionstart', () => {
            isComposing = true;
        });

        el.addEventListener('compositionend', (e) => {
            isComposing = false;
            handleInput(e);
        });
        el.addEventListener('input', handleInput);
        el.addEventListener('paste', (e) => {
            e.preventDefault();
            const text = e.clipboardData.getData('text');
            const numbersOnly = filterNumber(text);
            document.execCommand('insertText', false, numbersOnly);
        });
    }
}